export default {
  // 加载文本
  loading: "拼命加载中",
  
  // 标题和标签
  sharePermission: "分享权限",
  validPeriod: "有效期",
  addressHiding: "地址隐藏",
  canvasData: "画布数据",
  shareLink: "分享链接",
  accessPassword: "访问密码",
  
  // 选项
  viewOnlyOption: "仅查看画布（不需要登录，输入密码即可访问）",
  copyableOption: "可复制画布（输入密码可访问，允许用户复制画布，需要用户登录）",
  
  // 有效期选项
  day1: "1天",
  day3: "3天",
  day7: "7天",
  day14: "14天",
  day30: "30天",
  
  // 地址隐藏选项
  no: "否",
  yes: "是",
  
  // 画布数据
  tag: "标签",
  nodeComment: "节点备注",
  showAll: "显示全部",
  show: "显示",
  
  // 按钮
  copyLink: "复制链接",
  confirm: "确认",
  
  // 消息
  expiredHint: "有效期已过期，点击下方按钮重新分享",
  copySuccess: "复制成功",
  
  // 复制文案
  sharedCanvasFrom: "用户uid{uid}向您分享了他(她)的 {canvasName} 画布",
  link: "链接：",
  password: "密码：",
  validityPeriod: "有效期：",
  copyPermissionAllowed: "复制画布权限：允许",
  addressHidingYes: "地址隐藏 : 是",
  note: "请注意，这个链接有设置权限和有效期限制，请确保在有效期内输入密码进行访问",
  
  // 占位符
  pleaseSelect: "请选择",
};
